<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useKpiStore } from '@/stores/useKpiStore'
import ChartBar from '@/components/data-visualization/charts/ChartBar.vue'

const kpiStore = useKpiStore()

const {
  kpiOpportunityWon,
  kpiOpportunityCreated,
  loadingOpportunityWonKpi,
  loadingOpportunityCreatedKpi,
  errorOpportunityWon,
  errorOpportunityCreated,
} = storeToRefs(kpiStore)
</script>

<template>
  <ChartBar
    :data="kpiOpportunityWon || []"
    title="Affaires Gagnées"
    :loading="loadingOpportunityWonKpi"
    :error="errorOpportunityWon"
  />
  <ChartBar
    :data="kpiOpportunityCreated || []"
    title="Affaires Créées"
    :loading="loadingOpportunityCreatedKpi"
    :error="errorOpportunityCreated"
  />
</template>
